import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { HeaderComponent } from "src/app/header/header.component";
import { FooterComponent } from "src/app/footer/footer.component";
import { ClientsReviewComponent } from "src/app/clients-review/clients-review.component";
import { OurClienteleComponent } from "src/app/our-clientele/our-clientele.component";
import { RouterModule } from '@angular/router';
import { JsonLdService } from 'src/app/services/json-ld.service';
import { isPlatformBrowser } from '@angular/common';
import { GetStartedTodayComponent } from 'src/app/get-started-today/get-started-today.component';
@Component({
	selector: 'app-hubspot',
	templateUrl: './hubspot.component.html',
	styleUrls: ['./hubspot.component.css', '../mailchimp/mailchimp.component.css'],
	imports: [HeaderComponent, FooterComponent, GetStartedTodayComponent, RouterModule]
})
export class HubspotComponent implements OnInit {
	userDetail: any;
	isBrowser: boolean;
	constructor(
		private jsonldservice: JsonLdService,
		@Inject(PLATFORM_ID) private platformId: Object,
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
	}

	ngOnInit() {
		const clayJson = {
			"@context": "https://schema.org",
			"@graph": [
				{
					"@type": "Organization",
					"@id": "https://kudoshub.com/#organization",
					"name": "KudosHub",
					"url": "https://kudoshub.com",
					"logo": {
						"@type": "ImageObject",
						"url": "https://kudoshub.com/theme/images/og-images/logo.webp",
						"thumbnailUrl": "https://kudoshub.com/theme/images/og-images/logo.webp",
						"width": 160,
						"height": 160
					},
					"sameAs": [
						"https://www.facebook.com/KudosHub/",
						"https://www.linkedin.com/company/kudoshub/",
						"https://www.youtube.com/channel/UCN_L5eAxhiRYcjMd60y4gwg",
						"https://x.com/KudosHub"
					],
					"address": {
						"@type": "PostalAddress",
						"streetAddress": "Kalidas Road",
						"addressLocality": "Inder Vihar",
						"addressRegion": "Dehradun",
						"postalCode": "248001",
						"addressCountry": "IN"
					},
					"contactPoint": [
						{
							"@type": "ContactPoint",
							"telephone": "+91-9997100097",
							"contactType": "customer support",
							"availableLanguage": "en"
						}
					]
				},
				{
					"@type": "WebPage",
					"@id": "https://kudoshub.com/integrations/clay/#webpage",
					"url": "https://kudoshub.com/integrations/clay",
					"name": "Connect KudosHub with Clay.com to Automate Email Validation",
					"description": "Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.",
					"inLanguage": "en",
					"isPartOf": {
						"@id": "https://kudoshub.com/#website"
					},
					"datePublished": "2025-10-30T18:30:00+05:30",
					"dateModified": "2025-10-30T18:30:00+05:30"
				},
				{
					"@type": "Service",
					"@id": "https://kudoshub.com/integrations/clay/#service",
					"name": "KudosHub Email Validation using clay integration",
					"serviceType": "Email Validation using clay integration",
					"description": "KudosHub Email Validation API delivers real-time and bulk verification with 99% accuracy. It detects invalid, disposable, role-based, and catch-all addresses while reducing bounces and protecting sender reputation. Integrated AI email scoring enhances accuracy and provides deeper deliverability insights.",
					"offers": {
						"@type": "AggregateOffer",
						"url": "https://kudoshub.com/email-validation/#pricing",
						"priceCurrency": "USD",
						"lowPrice": "0",
						"highPrice": "0.0034",
						"offerCount": 2,
						"offers": [
							{
								"@type": "Offer",
								"name": "30-Day Free Trial (100 daily credits)",
								"description": "3,000 complimentary email validations (100 per day) for new users.",
								"price": "0",
								"priceCurrency": "USD",
								"url": "https://kudoshub.com/signup",
								"availability": "https://schema.org/InStock",
								"priceSpecification": {
									"@type": "UnitPriceSpecification",
									"unitText": "email validations",
									"price": "0",
									"unitCode": "C62"
								}
							},
							{
								"@type": "Offer",
								"name": "Commercial Volume Pricing",
								"description": "Per-validation cost drops from $0.0034 (low volume) down to $0.00055 (high volume). Enterprise quotes available.",
								"url": "https://kudoshub.com/pricing#commercial",
								"availability": "https://schema.org/InStock",
								"priceSpecification": {
									"@type": "UnitPriceSpecification",
									"unitText": "email validations",
									"priceCurrency": "USD",
									"minPrice": "0.00055",
									"maxPrice": "0.0034"
								}
							}
						]
					},
					"provider": {
						"@id": "https://kudoshub.com/#organization"
					},
					"url": "https://kudoshub.com/integrations/clay",
					"areaServed": "Worldwide"
				}
			]
		};
		const breadcrumb = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"@id": "https://kudoshub.com/integrations/clay/#breadcrumb",
			"itemListElement": [
				{
					"@type": "ListItem",
					"position": 1,
					"name": "Home",
					"item": "https://kudoshub.com/"
				},
				{
					"@type": "ListItem",
					"position": 2,
					"name": "Integrations",
					"item": "https://kudoshub.com/integrations/"
				},
				{
					"@type": "ListItem",
					"position": 3,
					"name": "Clay Integration",
					"item": "https://kudoshub.com/integrations/clay/"
				}
			]
		};
		this.jsonldservice.addJsonLd(clayJson, breadcrumb);
	}
	setUserDetails(data) {
		this.userDetail = data.userDetail;
	}


}
